import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const JobsPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.jobs.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.jobs.banner.image", src: "/assets/banners/jobs.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.jobs.banner.text.${locale}`} className="mb-5" />
        </Col>
      </Row>
    </Banner>
  );
};
